import { Name } from './application/index.js';
import { Timestamp } from './time/index.js';
import type { DecoderFunction } from './decoder.js';
import { z } from 'zod';

export type PojoObject = { [key: string]: unknown };
export const isPojoObject = (value: unknown): value is PojoObject => {
  return typeof value === 'object' && value !== null;
};

const namePojoSchema = z.object({
  first: z.string(),
  given: z.string().optional(),
  last: z.string(),
});

export const nameSchema = namePojoSchema.transform((obj) => {
  return new Name(obj);
});

export const timeStampSchema = Timestamp.schema;
export const timeStampDecoder: DecoderFunction<Timestamp> = (value: unknown) =>
  timeStampSchema.parse(value);

export const numberToDateSchema = z.number().transform((value) => new Date(value / 1000));
